'use client'

import { GuestView } from '@/ui/organisms/guest-view/GuestView'
import { EulerPositionView } from './views/EulerPositionView'
import { usePrivy } from '@privy-io/react-auth'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { useUnifiedPortfolio } from '@/features/portfolio'
import { useAccount } from 'wagmi'

function EulerPortfolioSkeleton() {
  return (
    <div className="flex flex-col gap-4 xl:flex-row">
      <div className="flex-1">
        <Skeleton className="h-[300px] w-full rounded-2xl" />
      </div>
      <div className="flex-1">
        <Skeleton className="h-[300px] w-full rounded-2xl" />
      </div>
    </div>
  )
}

export function EulerPortfolioContainer() {
  const { address } = useAccount()
  const portfolio = useUnifiedPortfolio()
  const { connectWallet } = usePrivy()
  const { elend: elendPositions, eborrow: eborrowPositions } = portfolio.positionData.euler
  const hasData = elendPositions.length > 0 || eborrowPositions.length > 0
  const isLoading = (portfolio.loading.eulerLend || portfolio.loading.eulerBorrow) && !hasData

  if (!address) {
    return <GuestView openConnectModal={connectWallet} />
  }

  // isLoading is only true when there's no cached data (initial load only, not refetches)
  if (isLoading) {
    return <EulerPortfolioSkeleton />
  }

  return <EulerPositionView elendPositions={elendPositions} eborrowPositions={eborrowPositions} />
}
